<template>
    <div class="widget" v-bind:class="[{'loaded':loaded},className]">

        <header class="widget-header">
            <h2 class="widget-title">{{ title }}</h2>
            <h3 class="widget-title-period">
                <span v-for="item in periods" v-if="item.id == period">{{ item.label }}</span>
            </h3>

            <div class="widget-actions-container">
            <widget-dropdown v-model="period" :options="periods" :callback="filterByPeriod"></widget-dropdown>
            </div>

            <div class="form-advanced-filter" v-if="showAdvancedFilterVue">
                <span>Filtrer par date</span>
                <div class="date-filters">
                    <form-datex label="du" v-model="dateFilter.start_at" :hide-time="false" time="00:00:00"></form-datex>
                    <form-datex label="au" v-model="dateFilter.end_at" :hide-time="false" time="23:59:59"></form-datex>
                </div>
            </div>

        </header>

        <div class="widget-preloader">
            <div class="pre-loader">
                <div class="box1"></div>
                <div class="box2"></div>
                <div class="box3"></div>
                <div class="box4"></div>
                <div class="box5"></div>
            </div>
        </div>

        <div class="widget-content" v-if="stats.dataset">
            <div class="widget-content-datas">
                <div v-for="item, key in total" style="padding: 20px 0;">
                    <div class="data-label tab" @click="selectData(key)" v-bind:class="{active: selected == key}">
                        <strong>{{ item.value }}</strong>
                        <span class="compare increase" v-if="item.last < item.value">+ {{ (item.value - item.last) }}</span>
                        <span class="compare decrease" v-if="item.last > item.value">- {{ (item.last - item.value) }}</span>
                        <img :src="'/src/assets/images/'+item.lead+'.png'" v-if="item.lead" width="30" :title="item.name"/>
                    </div>
                </div>
            </div>

            <div class="widget-chart" v-bind:class="{'active':stats.labels.length}">
                <chart :dataset="stats.dataset" :labels="stats.labels" :options="options" v-if="stats"></chart>
            </div>
            <!--
            <div v-for="item in stats.dataset">
                {{ item.name }} {{ item.value }}
            </div>
            -->
        </div>
    </div>
</template>
<script>

    import GoogleAnalyticsService from './GoogleAnalyticsService.js';
    import Line from '../../components/chart/Bar.vue'

    export default {
        name: 'Widget',
        components: {
            'chart' : Line
        },
        props: ['title','period','className'],
        data () {
            return {
                periods: [
                    {id: 'last_7days', label: '7 derniers jours'},
                    {id: 'current_month', label: 'Ce mois'},
                    {id: 'last_month', label: 'Le mois dernier'},
                    {id: 'since_1_month', label: '30 derniers jours'},
                    {id: 'since_3_months', label: '90 derniers jours'},
                    {id: 'current_year', label: 'Cette année'},
                    {id: 'last_year', label: 'Depuis 12 mois'},
                    {id: 'all', label: 'Tout'},
                    {id: 'custom', label: 'Personnalisé'},
                ],
                loaded: false,
                stats: {
                    dataset: null,
                    labels: null
                },
                dateFilter: {
                    start_at: '',
                    end_at: '',
                },
                showAdvancedFilterVue: false,
                count: null,
                total: null,
                options: {
                    legend: {
                      labels: {
                        usePointStyle: true,
                        boxWidth: 6,
                        fontSize: 11,
                        fontFamily: 'Gotham Rounded',
                        fontWeight: 100
                      }
                    },
                    layout: {
                        padding: {
                            left: 0,
                            right: 10,
                            top: 0,
                            bottom: 0
                        }
                    },
                    scales: {
                        xAxes: [ {
                            //categoryPercentage: 0.9,
                            //barPercentage: 0.9,
                            stacked: true,
                            steppedLine: true,
                            gridLines: {
                                offsetGridLines: false,
                                display: false,
                                color: "#dddddd",
                                drawBorder: false
                            },
                            ticks: {
                                display: true,
                                fontColor: "#aaaaaa",
                                fontSize: 12,
                            },
                        }],
                        yAxes: [ {
                            stacked: true,
                            steppedLine: true,
                            gridLines: {
                                offsetGridLines: true,
                                display: true,
                                color: "#dddddd",
                                borderDashOffset: 1,
                                borderDash: [2,2],
                                drawBorder: false
                            },
                            ticks: {
                                fontColor: "#aaaaaa",
                                fontSize: 12,
                                display: true,
                                padding: 0,
                                //stepSize: 1,
                                //suggestedMax: 0,
                                //suggestedMin: 0
                            }
                        }]
                    },
                    plugins: {
                        labels: false
                    }
                }
            }
        },
        mounted: function(){

            this.period = this.period ? this.period : this.periods[0].id

            if(this.period == 'custom') {
                this.showAdvancedFilterVue = true
            }else{
                this.showAdvancedFilterVue = false;
            }

            this.filterByPeriod(this.period);

        },
        watch: {
            'dateFilter.start_at'(newVal, oldVal) {
                if(newVal != '' && this.dateFilter.end_at != ''){
                    this.filterByPeriodAndByDate(this.period, this.dateFilter);
                }
            },
            'dateFilter.end_at'(newVal, oldVal) {
                if(newVal != '' && this.dateFilter.start_at != ''){
                    this.filterByPeriodAndByDate(this.period, this.dateFilter);
                }
            }
        },
        methods: {
            filterByPeriod: function(period)
            {

                if(period == 'custom') {
                    this.showAdvancedFilterVue = true
                }else{
                    this.showAdvancedFilterVue = false;
                }

                if(period != 'custom') {

                    this.loaded = false;
                    this.period = period

                    GoogleAnalyticsService.getSources( this.period ).then((response) => {
                        this.stats.dataset = response.data.result.stats.dataset
                        this.stats.labels = response.data.result.stats.labels
                        this.total = response.data.result.total

                        this.loaded = true;
                    }).catch((response) => {
                        console.log("error", response);
                        this.loaded = true;
                    })

                }
            },
            filterByPeriodAndByDate: function(period, dateFilter)
            {
                this.loaded = false;

                this.period = period
                this.date = JSON.stringify(dateFilter);

                GoogleAnalyticsService.getSources( this.period, this.date ).then((response) => {
                    this.stats.dataset = response.data.result.stats.dataset
                    this.stats.labels = response.data.result.stats.labels
                    this.total = response.data.result.total

                    this.loaded = true;
                }).catch((response) => {
                    console.log("error", response);
                    this.loaded = true;
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/google/GoogleAnalyticsSourcesWidget.vue